import styled from 'styled-components';

import { COLORS, ANIM } from '../../theme/tokens';
import { Text } from '../Text/Text';

export const Root = styled.button<{ $selected: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  border-radius: 99px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid ${(p) => (p.$selected ? COLORS.ctaBorder : COLORS.panelBorder)};
  background: ${(p) => (p.$selected ? COLORS.ctaTint : COLORS.surfaceSoft)};
  color: ${(p) => (p.$selected ? COLORS.text : COLORS.textMuted)};
  transition: border-color ${ANIM.INTERACT_MS}ms ease, background ${ANIM.INTERACT_MS}ms ease, color ${ANIM.INTERACT_MS}ms ease;
`;

export const Label = styled(Text)`
  line-height: 1;
`;